import { Component, Input, Output, EventEmitter } from '@angular/core';
import moment from "moment";
import {TxpScenarioCountryCode} from '@features/global-tax-calculator/models/txp.constants';

@Component({
    standalone: false,
    selector: 'app-gtc-scenario-tags',
  templateUrl: './gtc-scenario-tags.component.html',
  styleUrls: ['./gtc-scenario-tags.component.scss']
})
export class GtcScenarioTagsComponent {
  @Input() tags: string[] = [];
  @Input() data: any;
  @Input() tagClassMap: any;
  @Input() templateUpdateChoices: any;
  @Input() isCountryTrackerUpdateAvailable: any;
  @Input() isTemplateUpdateAvailable: any;
  @Input() isLegacyTemplate: boolean;
  @Input() isIncomplete: boolean;
  @Input() versionTooltips: {
    [key: string]: string;
  };
  @Input() isLocked: boolean = false;
  @Input() lockedScenarioMessage: string = '';
  @Output() tagClick = new EventEmitter<{event: Event, tag: string}>();


  tagClass(tag: any) {
    let className = '';
    if(this.isMasterScenario(tag)){
      className = className + ' ' + 'master-scenario';
    }
    if(this.isIncomplete){
      className = className + ' ' + 'incomplete';
      return className;
    }
    if(this.isLegacyTemplate){
      className = className + ' ' + 'legacy-template' + ' ' + 'active';
      return className;
    }
    if(!this.isTemplateUpdateAvailable[tag] && !this.isCountryTrackerUpdateAvailable[tag]){
      className = className + ' ' + 'active';
      return className;
    }
    if(!this.templateUpdateChoices[tag] || this.templateUpdateChoices[tag].updateSettings !== 'ScheduleUpdates'){
      className = className + ' ' + 'update-available';
      return className;
    }
    if(this.templateUpdateChoices[tag]){
      const templateUpdateChoice = this.templateUpdateChoices[tag];
      if(this.tagClassMap[templateUpdateChoice.updateSettings]){
        className = className + ' ' + this.tagClassMap[templateUpdateChoice.updateSettings];
        return className;
      }
    }
    return 'active';
  }

  getVersionToolTip(tag){
    let versionMessage =  this.versionTooltips?.[tag] || ''
    if(!this.isTemplateUpdateAvailable[tag]){
      return versionMessage  ;
    }
    return versionMessage  ;
  }


  getMasterScenarioToolTip(scenarioType:string):string{
      let isMasterScenario = this.isMasterScenario(scenarioType);
      let title = scenarioType == 'GMT' ? 'Compliance' : 'Master';
      let message = '<p>'+title+' Scenario</p>';
       return isMasterScenario ? message : '';
  }
  getScheduleUpdateTooltip(tag){
    if(this.templateUpdateChoices[tag]){ //In progress
      const templateUpdateChoice = this.templateUpdateChoices[tag];
      if(templateUpdateChoice.updateSettings === 'ScheduleUpdates'){
        const localTime = this.convertUTCToLocalFormatted(templateUpdateChoice.scheduleDate);
        return `<div class="schedular-tooltip-container"><h4>Update(s) Scheduled</h4><p>Updates are scheduled for ${localTime}</p></div>`
      }
    }
    return '';
  }

  getTemplateUpdateVersionTooltip(tag){
    if((this.isTemplateUpdateAvailable[`${tag}-${TxpScenarioCountryCode.TaxPack}`] || this.isTemplateUpdateAvailable[`${tag}-${TxpScenarioCountryCode.TaxConsolidation}`]) && (!this.templateUpdateChoices[tag] || this.templateUpdateChoices[tag]?.updateSettings !== 'ScheduleUpdates')){
      let versionsHtml = '';
      if(this.isTemplateUpdateAvailable[`${tag}-${TxpScenarioCountryCode.TaxPack}`]){
        const current = this.data.cells[`${tag}-${TxpScenarioCountryCode.TaxPack}-CurrentVersion`]?.value;
        const updated = this.data.cells[`${tag}-${TxpScenarioCountryCode.TaxPack}-UpdatedVersion`]?.value;
        versionsHtml += `Current TaxPack Template: ${current}<br>New TaxPack Template: ${updated}`;
      }
      if(this.isTemplateUpdateAvailable[`${tag}-${TxpScenarioCountryCode.TaxConsolidation}`]){
        if(versionsHtml) versionsHtml += '<br>';
        const current = this.data.cells[`${tag}-${TxpScenarioCountryCode.TaxConsolidation}-CurrentVersion`]?.value;
        const updated = this.data.cells[`${tag}-${TxpScenarioCountryCode.TaxConsolidation}-UpdatedVersion`]?.value;
        versionsHtml += `Current TaxConsolidation Template: ${current}<br>New TaxConsolidation Template: ${updated}`;
      }
      return `<div class="schedular-tooltip-container">
        <h4>Update(s) Available</h4><p>${versionsHtml}</p>
        <p>Open this scenario to view the possible update options.</p></div>`;
    }
    else if(this.isCountryTrackerUpdateAvailable[tag] && this.isTemplateUpdateAvailable[tag] && (!this.templateUpdateChoices[tag] || this.templateUpdateChoices[tag]?.updateSettings !== 'ScheduleUpdates')){
      const updateVersion = this.data.cells[`${tag}-UpdatedVersion`]?.value;
      const currentVersion = this.data.cells[`${tag}-CurrentVersion`]?.value;
      const currentCtVersion = this.data.cells[`${tag}-CurrentCountryTrackerVersion`]?.value;
      const updateCtVersion = this.data.cells[`${tag}-UpdatedCountryTrackerVersion`]?.value;
      return `<div class="schedular-tooltip-container">
        <h4>Update(s) Available</h4>
        <p>Current Country Tracker: ${currentCtVersion}<br> New Country Tracker: ${updateCtVersion}
        <br>Current ${tag} Template: ${currentVersion}<br>New ${tag} Template: ${updateVersion}</p>
        <p>Open this scenario to view the possible update options.</p></div>`
    }
    else if(this.isTemplateUpdateAvailable[tag] && (!this.templateUpdateChoices[tag] || this.templateUpdateChoices[tag]?.updateSettings !== 'ScheduleUpdates')) {
      const updateVersion = this.data.cells[`${tag}-UpdatedVersion`]?.value;
      const currentVersion = this.data.cells[`${tag}-CurrentVersion`]?.value;
      return `<div class="schedular-tooltip-container">
        <h4>Update(s) Available</h4><p>Current ${tag} Template: ${currentVersion}<br>New ${tag} Template: ${updateVersion}
        <p>Open this scenario to view the possible update options.</p></div>`
    }
    else if(this.isCountryTrackerUpdateAvailable[tag] && (!this.templateUpdateChoices[tag] || this.templateUpdateChoices[tag]?.updateSettings !== 'ScheduleUpdates')) {
      const currentCtVersion = this.data.cells[`${tag}-CurrentCountryTrackerVersion`]?.value;
      const updateCtVersion = this.data.cells[`${tag}-UpdatedCountryTrackerVersion`]?.value;
      return `<div class="schedular-tooltip-container">
        <h4>Update(s) Available</h4><br>Current Country Tracker: ${currentCtVersion}<br>New Country Tracker: ${updateCtVersion}</p>
        <p>Open this scenario to view the possible update options.</p></div>`
    }

    return '';
  }

  onTagClick(event: Event, tag: string): void {
    this.tagClick.emit({event, tag});
  }
  convertUTCToLocalFormatted(utcDateTime) {
    let localTime = moment.utc(utcDateTime).local();
    return localTime.format('D MMMM, YYYY [at] hh:mm A');
  }
  isMasterScenario(scenarioType: string): boolean {
    return !!this.data.cells['Is' + scenarioType + 'MasterScenario']?.value;
  }

  getLegacyTemplateVersionTooltip(tag: any): string {
    return this.data?.cells?.[tag + 'LegacyTemplateToolTip']?.displayText ?? '';
  }

  getIncompleteTooltip(tag: string): string {
    if (this.isIncomplete) {
      return '<div class="schedular-tooltip-container"><h4>Incomplete Scenario</h4><p>This scenario is incomplete. Please click the tile to complete the scenario creation process.</p></div>';
    }
    return '';
  }
}
